import React, { useState, useEffect, useMemo } from "react";
import { Link, useParams } from "react-router-dom";
import { api } from "../../../utils/Api";
import ModalServiceView from "./ModalServiceView";

export default function OrderRequest(props: any) {
  const [id_value, SerIdValue] = useState(useParams());
  const [table_change_value, SetTableChangeValue] = useState({
    search_filter: "",
    page_size: 10,
    sort_order: false,
    page_no: 1,
    // filter: "unaccepted",
  });
  const [order_request_data, SetOrderRequestData] = useState([]);
  const [modal_sercice_view, SetModalSericeView] = useState({
    is_open: false,
    data: {},
  });
  const [selected_filter, SetSelectedFilter] = useState("");

  const filter_data = [
    {
      name: "Unaccepted",
      value: "unaccepted",
    },
    {
      name: "Accepted",
      value: "accepted",
    },
    {
      name: "Rejected",
      value: "rejected",
    },
    {
      name: "Cancelled",
      value: "cancelled",
    },
  ];

  useEffect(() => {
    console.log("OrderRequest On mount :", props);
    SetSelectedFilter((prevValue) => {
      prevValue = "unaccepted";
      return prevValue;
    });
    get_order_request(table_change_value, "unaccepted");
  }, []);

  async function get_order_request(data: any, selected_filter_value) {
    console.log("OrderRequest data :", data);
    let count_value, sort_order_value;
    if (data.page_size == "0") {
      count_value = "all";
    } else {
      count_value = data.page_size;
    }
    if (data.sort_order == false) {
      sort_order_value = "desc";
    } else {
      sort_order_value = data.sort_order;
    }
    let pass_data = {
      get: {
        brand: id_value.brand_id,
        outlet: id_value.outlet_id,
        page: data.page_no,
        count: count_value,
        search: data.search_filter,
        // sort,
        // sort_by,
        // filter : "",
      },
    };
    if (id_value.company_id != "all") {
      pass_data.get.company_id = id_value.company_id;
    }

    // if (data.filter != "unaccepted") {
    //   pass_data.get.filter = data.filter;
    // }

    if (selected_filter_value != "unaccepted") {
      pass_data.get.filter = selected_filter_value;
    }

    let response = await api("/outlet/order_request", pass_data);
    console.log("Outlet dashboard response :", response.response);
    if (response.response.hasOwnProperty("orders")) {
      SetOrderRequestData(response.response.orders);
    } else {
      SetOrderRequestData([]);
    }
    SetTableChangeValue((prevValue) => {
      if (response.response.next_page) {
        prevValue.page_no = prevValue.page_no + 1;
      }
      return { ...prevValue };
    });
  }

  async function reject_order(order_id_value: any) {
    let pass_data = {
      get: { brand: id_value.brand_id, outlet: id_value.outlet_id },
      post: { order_id: order_id_value },
    };
    console.log(" reject_order pass data :", pass_data);
    let data = await api("/outlet/reject_order_request", pass_data);
    console.log("reject_order_request response :", data);
    if (data.response.hasOwnProperty("status")) {
      if (data.response.status) {
        get_order_request(table_change_value, selected_filter);
      }
    }
  }

  function capitalizeFirstLetter(string) {
    if (string != undefined) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    }
  }

  return (
    <div>
      <div className="bg-fff pt-3 px-4 ">
        <div className="row align-items-center pb-2">
          <div className="col-md-5 col-6">
           <div className="d-flex">
           {id_value.company_id != "all" ? (
              <div
                // className="btn btn-light-outline"
                onClick={() => {
                  window.history.back();
                }}
              >
                <img src={require("../../../assets/icon/svg/arrow-left.svg")} className="pe-2 action-img" />
              </div>
            ) : null}
            <h6 className="mb-0 text-dark fw-bolder">
              {capitalizeFirstLetter(selected_filter)} Order Request
            </h6>
           </div>
          </div>
          <div className="col-md-7 col-6 justify-content-end d-flex align-items-center">
            <div className="ms-2 ps-2 cursor dropdown">
              <div
                className="border d-flex align-items-center p-2"
                id="dropdownMenuButton"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                <img
                  src={require("../../../assets/icon/svg/sliders1.svg")}
                  className="header-icon-img"
                />
                <p className="mb-0 text-dark ps-2">Filter</p>
              </div>
              <ul
                className="dropdown-menu"
                aria-labelledby="dropdownMenuButton"
              >
                {filter_data.map((f_ele, f_index) => (
                  <li
                    key={f_index}
                    onClick={() => {
                      // SetSelectedFilter(f_ele.value);
                      SetSelectedFilter((prevValue) => {
                        prevValue = f_ele.value;
                        return prevValue;
                      });
                      get_order_request(table_change_value, f_ele.value);
                    }}
                    className={
                      selected_filter == f_ele.value
                        ? "filter p-1"
                        : "cursor p-1 text-dark"
                    }
                  >
                    <a className="dropdown-item">{f_ele.name}</a>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div className="container p-3">
        <div className="card p-3">
          <div className="row">
            {order_request_data.length > 0 ? (
              order_request_data.map((o_ele: any, o_index: any) => (
                <div className="col-sm-6 mb-2" key={o_index}>
                  <div className="border p-3">
                    <h6 className="fs-6 mb-3">{o_ele.company_name}</h6>

                    <div className="row">
                      <div className="col-6">
                        <p>No of Services : {o_ele.services.length}</p>
                      </div>
                      <div className="col-6 text-end">
                        <p className="text-primary">{o_ele.status}</p>
                      </div>
                    </div>
                    <p className="text-dark fs-7">Created By : {o_ele.created_user} @ {o_ele.created_username}
                    </p>
                    <p className="text-gray v-small">{o_ele.created_at}</p>

                    <div className="d-flex">
                      <button
                        className="btn btn-light-outline"
                        onClick={() => {
                          console.log(
                            "Accept / View table_change_value:",
                            table_change_value
                          );
                          SetModalSericeView((prevValue) => {
                            prevValue.is_open = true;
                            prevValue.data = o_ele;
                            return { ...prevValue };
                          });
                        }}
                      >
                        {selected_filter == "unaccepted" ? "Accept" : "View"}
                      </button>
                      {selected_filter == "unaccepted" ? (
                        <button
                          className="btn btn-light-outline ms-auto"
                          onClick={() => {
                            console.log("Reject");
                            reject_order(o_ele.id);
                          }}
                        >
                          Reject
                        </button>
                      ) : null}
                    </div>
                  </div>

                </div>
              ))
            ) : (
              <div className="text-center">
              <img
                src={require("../../../assets/img/svg/no_data_2.svg")}
                className="w-30 pb-2"
              />
              <p className="v-small mb-0">No {capitalizeFirstLetter(selected_filter)} Order Request</p>
            </div>
            )}
          </div>
        </div>
      </div>

      <ModalServiceView
        open={modal_sercice_view.is_open}
        data={modal_sercice_view.data}
        filter_value={selected_filter}
        close={(data) => {
          console.log("ModalServiceView on close :", data);
          SetModalSericeView((prevValue) => {
            prevValue.is_open = false;
            return { ...prevValue };
          });
          console.log("ModalServiceView selected_filter: ", selected_filter);
          get_order_request(table_change_value, data.filter_value);
        }}
      />
    </div>
  );
}
